module.exports = __webpack_public_path__ + "img/consent-active.bf68406d.svg";